module.exports = __webpack_public_path__ + "img/9788971996119.34ce3cea.jpg";